import { Box, Select } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { FieldValues, useFormContext, UseFormRegister } from 'react-hook-form';

import { NewCar } from '@/types/new-cars/new-cars.types';

import Styles from './newCar-select.module.scss';
type NewCarSelectProps<T extends FieldValues = FieldValues> = {
  newCars: NewCar[];
  selectedNewCarId?: number | null;
  setSelectedNewCarId: (id: number) => void;
  required?: boolean;
  name?: string;
  disabled?: boolean;
  register?: UseFormRegister<T>;
};
function NewCarSelect<T extends FieldValues = FieldValues>({
  newCars,
  selectedNewCarId,
  setSelectedNewCarId,
  required,
  name,
  disabled,
  register: propRegister,
}: NewCarSelectProps<T>) {
  const formContext = useFormContext();
  const { register: contextRegister, setValue, trigger } = formContext || {};

  const register = contextRegister || propRegister;

  const selectedNewCar = newCars.find((car) => car.id === selectedNewCarId);

  useEffect(() => {
    if (selectedNewCarId && name && setValue && trigger) {
      setValue(name, selectedNewCarId.toString(), { shouldValidate: true });
      trigger(name);
    }
  }, [selectedNewCarId, name, setValue, trigger]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;

    setSelectedNewCarId(parseInt(value));
  };

  const registerProps = register
    ? register(name || '', {
        required: required && 'Please select a model',
        onChange: handleChange,
      })
    : { onChange: handleChange, name };

  return (
    <Box className={Styles.customSelect}>
      <Select
        className={Styles.formInput}
        placeholder="Select model"
        variant="flushed"
        value={selectedNewCar ? selectedNewCar.id.toString() : ''}
        {...registerProps}
        name={name}
        disabled={disabled}
        aria-label="select model"
      >
        <option value="" disabled>
          Select model
        </option>
        {newCars?.map((item) => (
          <option key={item.id} value={item.id.toString()}>
            {item?.main_title}
          </option>
        ))}
      </Select>
    </Box>
  );
}

export default NewCarSelect;
